/* tslint:disable */
/* eslint-disable */
/**
 * Products API
 * API for managing products
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Theme colors for the product owner
 * @export
 * @interface ProductOwnerThemeDto
 */
export interface ProductOwnerThemeDto {
    /**
     * Primary color in hex format
     * @type {string}
     * @memberof ProductOwnerThemeDto
     */
    primaryColor?: string | null;
    /**
     * Secondary color in hex format
     * @type {string}
     * @memberof ProductOwnerThemeDto
     */
    secondaryColor?: string | null;
}

/**
 * Check if a given object implements the ProductOwnerThemeDto interface.
 */
export function instanceOfProductOwnerThemeDto(value: object): value is ProductOwnerThemeDto {
    return true;
}

export function ProductOwnerThemeDtoFromJSON(json: any): ProductOwnerThemeDto {
    return ProductOwnerThemeDtoFromJSONTyped(json, false);
}

export function ProductOwnerThemeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductOwnerThemeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'primaryColor': json['primaryColor'] == null ? undefined : json['primaryColor'],
        'secondaryColor': json['secondaryColor'] == null ? undefined : json['secondaryColor'],
    };
}

export function ProductOwnerThemeDtoToJSON(json: any): ProductOwnerThemeDto {
    return ProductOwnerThemeDtoToJSONTyped(json, false);
}

export function ProductOwnerThemeDtoToJSONTyped(value?: ProductOwnerThemeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'primaryColor': value['primaryColor'],
        'secondaryColor': value['secondaryColor'],
    };
}

